"use strict";

const AppStorage = class AppStorage {

	/**
	 * @param type
	 * @param parameters
	 */
	constructor(type, parameters) {
		this._type = '';
		this._prefix = 'app_';

		this._params = parameters || {};

		if (!this._type) this._type = 'localStorage';
		this._prefix += this._type;

		this.checkAvailable(this._type);
	}

	/**
	 * @param type
	 * @returns {boolean}
	 */
	checkAvailable = (type = 'localStorage') => {
		let storage;
		try {
			storage = window[type];
			const x = '__storage_test__';
			storage.setItem(x, x);
			storage.removeItem(x);
			return true;
		} catch (e) {
			return e instanceof DOMException && (
					// everything except Firefox
					e.code === 22 ||
					// Firefox
					e.code === 1014 ||
					// test name field too, because code might not be present
					// everything except Firefox
					e.name === 'QuotaExceededError' ||
					// Firefox
					e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
				// acknowledge QuotaExceededError only if there's something already stored
				(storage && storage.length !== 0);
		}
	};

	/**
	 * @param name
	 * @param value
	 */
	add = (name, value) => {
		if (!name || !value) return;

		let storage = this._get();
		if (!storage) storage = {}; else storage = JSON.parse(storage);

		if (!storage.hasOwnProperty(name)) storage[name] = [];
		if (storage[name].indexOf(value) === -1) storage[name].push(value);

		this._set(storage);
	};

	/**
	 * @param name
	 * @param value
	 */
	delete = (name, value) => {
		if (!name || !value) return;

		let storage = this._get();
		if (storage) storage = JSON.parse(storage);

		if (storage.hasOwnProperty(name)) {
			let index = storage[name].indexOf(value);
			if (index !== -1) {
				storage[name].splice(index, 1);
				this._set(storage);
			}
		}
	};

	/**
	 * @param name
	 * @param value
	 */
	set = (name, value) => {
		if (!name || (!value && value !== 0)) return;

		let storage = this._get();
		if (!storage) storage = {}; else storage = JSON.parse(storage);

		storage[name] = value;

		this._set(storage);
	};

	/**
	 * @param name
	 * @param _default
	 * @returns {*|null}
	 */
	get = (name, _default = null) => {
		let storage = this._get();

		if (!storage) return _default;
		storage = JSON.parse(storage);

		if (storage && storage.hasOwnProperty(name)) {
			let value = storage[name];
			if (value) return value;
		}

		return _default;
	};

	/**
	 * @param storage
	 * @private
	 */
	_set = (storage) => {
		if (!storage) return;

		window[`${this._type}`].setItem(`${this._prefix}`, JSON.stringify(storage));
	};

	/**
	 * @returns {*}
	 * @private
	 */
	_get = () => {
		return window[`${this._type}`].getItem(`${this._prefix}`);
	};
}

export {AppStorage};